import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { AngularSvgIconModule } from "angular-svg-icon";
import { LandingNavItem } from "./landing-nav-item.model";
import { DisplayWidgetComponent } from "@app/common/display-widget/display-widget.component";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ButtonComponent } from "@app/common/button/button.component";
/**
 * Component that represents a single navigation item on the landing page.
 * Each item is displayed as a themed card with expandable content,
 * including a title, description, and action button.
 */
@Component({
  selector: "app-landing-nav-item",
  templateUrl: "./landing-nav-item.component.html",
  styleUrls: ["./landing-nav-item.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    AngularSvgIconModule,
    RouterModule,
    DisplayWidgetComponent,
    ButtonComponent,
  ],
})
export class LandingNavItemComponent {
  /** The navigation item data containing theme, content, title, and action information */
  @Input() public set item(value: LandingNavItem) {
    this._item = value;
    this.processContent();
  }

  public get item(): LandingNavItem {
    return this._item;
  }
  private _item: LandingNavItem;

  /** Whether to use expand features (expand/collapse functionality) */
  @Input() useExpandFeatures: boolean = true;

  @Input() applyContentBorder: boolean = false;

  /** Tracks the expanded/collapsed state of the navigation item */
  isExpanded: boolean = true;

  /** Processed content with 'flip' word wrapped in a span */
  processedContent: SafeHtml = "";

  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Processes the content to wrap the word 'flip' in a span with the 'flip-word' class
   */
  processContent() {
    if (this.item.content) {
      // Replace the word 'flip' with a span containing the class 'font-bold'
      // Using a more specific regex to match the word 'flip' as a whole word
      const processedText = this.item.content.replace(
        /\b(flip)\b/gi,
        '<span class="font-bold">$1</span>'
      );

      this.processedContent =
        this.sanitizer.bypassSecurityTrustHtml(processedText);
    }
  }

  /**
   * Toggles the expanded/collapsed state of the navigation item
   * Used to show/hide additional content
   */
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  navigateToUrl() {
    if (this.item.url) {
      window.open(this.item.url, "_blank");
    }
  }
}
